module.exports = "/images/Homepage-What You Get.jpg";